import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_AI_SETTINGS = {
  id: null,
  isEnabled: false,
  framework: "OLLAMA",
  settings: null,
  isStreamingEnabled: false,
  isRagEnabled: false,
  ragSettings: null,
  isSharepointDownloadEnabled: false,
  authenticationMethod: "IAM",
  genAiManagedByConfig: false,
  ragManagedByConfig: false,
};

export const INITIAL_STATE = {
  settings: INITIAL_AI_SETTINGS,
  areAIConnectionsTested: false,
  edits: {},
  error: false,
  isAiEnabledInitialized: false,
  isTesting: false,
  isLlmAvailable: true,
  isOutlineGenerationAvailable: true,
  analysisLlm: null,
  visiEverywhere: null,
  visiEverywhereProvider: null,
};

export const generativeAiSlice = createSlice({
  name: "generativeAi",
  initialState: INITIAL_STATE,
  reducers: {
    setAreAIConnectionsTested: (state, { payload: areAIConnectionsTested }) => {
      state.areAIConnectionsTested = Boolean(areAIConnectionsTested);
    },
    setGenerativeAISettings: (state, { payload }) => {
      state.settings = payload;
    },
    updateGenerativeAISettings: (state, { payload }) => {
      state.settings = { ...state.settings, ...payload };
    },
    setEdits: (state, { payload }) => {
      state.edits = { ...state.edits, ...payload };
    },
    resetEdits: (state) => {
      state.edits = {};
    },
    setIsTesting: (state, { payload }) => {
      state.isTesting = payload;
    },
    setIsRagEnabled: (state, { payload }) => {
      state.settings.isRagEnabled = payload;
    },
    setIsLocalFileSharingEnabled: (state, { payload }) => {
      state.settings.ragSettings = {
        ...state.settings.ragSettings,
        isLocalFileSharingEnabled: payload,
      };
    },
    setIsLlmAvailable: (state, { payload }) => {
      state.isLlmAvailable = payload;
    },
    setIsOutlineGenerationAvailable: (state, { payload }) => {
      state.isOutlineGenerationAvailable = payload;
    },
    setAnalysisLlm: (state, { payload }) => {
      state.analysisLlm = payload;
    },
    setVisiEverywhereFeature: (state, { payload }) => {
      state.visiEverywhere = payload;
    },
    setVisiEverywhereProvider: (state, { payload }) => {
      state.visiEverywhereProvider = payload;
    },
    setIsAiEnabledInitialized: (state) => {
      state.isAiEnabledInitialized = true;
    },
  },
});

export const {
  setVisiEverywhereFeature,
  setVisiEverywhereProvider,
  setAreAIConnectionsTested,
  setGenerativeAISettings,
  updateGenerativeAISettings,
  setEdits,
  resetEdits,
  setIsAiEnabledInitialized,
  setIsTesting,
  setIsRagEnabled,
  setIsLocalFileSharingEnabled,
  setIsLlmAvailable,
  setIsOutlineGenerationAvailable,
  setAnalysisLlm,
} = generativeAiSlice.actions;

export default generativeAiSlice.reducer;
